import React from 'react';

export enum IconColors {
  Primary = 'primary',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

export type Item = {
  title: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  iconColor?: IconColors;
  description?: string;
};
